import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';
import { Essentials } from '@domains/pdp-common';

interface EssentialsContentsProps {
  is_opened: boolean;
  essentials: Essentials[];
  show_essentials: boolean;
  show_product_information: boolean;
  onClickPdpLink: () => void;
  onClickInquiry: () => void;
}

export const ProductInfoProvidedNoticeContents: React.FC<React.PropsWithChildren<EssentialsContentsProps>> = ({
  is_opened,
  essentials,
  show_essentials,
  show_product_information,
  onClickPdpLink,
  onClickInquiry,
}) => {
  return (
    <Contents className={Typography.CAPTION_12_REGULAR} is_opened={is_opened}>
      {show_essentials &&
        essentials.map(({ name, value }) => (
          <Row key={name}>
            <Label className={Typography.CAPTION_12_MEDIUM}>{name}</Label>
            <Value className={Typography.CAPTION_12_REGULAR} dangerouslySetInnerHTML={{ __html: value }} />
          </Row>
        ))}
      {show_product_information && (
        <Notice has_top_padding={show_essentials}>
          위 내용은 공정거래위원회 '상품정보제공고시'에 따라 판매자가 등록한 정보로 해당 정보에 대한 책임은 판매자에게 있습니다.
          <br />
          상품 관련 추가 정보는{' '}
          <button type='button' className='link' onClick={onClickPdpLink}>
            자사몰 상품 상세 페이지
          </button>
          를 확인하시거나
          <br />
          <button type='button' className='link' onClick={onClickInquiry}>
            판매자에게 문의
          </button>
          하시기 바랍니다.
          <br />
        </Notice>
      )}
    </Contents>
  );
};

const Contents = styled.div<{ is_opened?: boolean }>`
  height: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;

  ${({ is_opened }) =>
    is_opened &&
    css`
      height: auto;
      padding: 0 16px 8px 16px;
    `}
`;

const Row = styled.div`
  display: flex;
  min-height: 30px;
  padding: 8px 0;
`;

const Label = styled.span`
  max-width: 124px;
  width: 100%;
  padding: 0 30px 0 0;
  color: ${vars.v3Color.gray500};
`;

const Value = styled.span`
  max-width: 100%;
  width: 100%;
  color: ${vars.v3Color.gray700};

  b {
    font-weight: 700;
  }
`;

const Notice = styled.div<{ has_top_padding: boolean }>`
  margin: ${({ has_top_padding }) => (has_top_padding ? '16px 0 0 0' : '0')};
  padding: 8px 0 40px;
  font-size: 11px;
  line-height: 145%;
  color: ${vars.v3Color.gray400};

  .link {
    text-decoration: underline;
    cursor: pointer;
    color: ${vars.v3Color.gray900};
  }
  span {
    display: block;
    padding: 0 32px 0 8px;
  }
`;
